import type { PreviewCopy, TypeAnswers } from "../domain.js";

export type EntryRoute = "type" | "collection";
export type TypePath = "quick" | "deep";

export type SharedBrief = {
  route: EntryRoute;
  typePath?: TypePath;
  artifactType?: string;
  otherDecision?: string;
  existingFontConstraint?: TypeAnswers["existingFontConstraint"];
  mandatoryFontName?: string;
  authoringTool?: string;
  handoffPaths?: string[];
  viewingContexts?: string[];
  density?: TypeAnswers["density"];
  contentNeeds?: string[];
  writingSystems?: string[];
  character?: TypeAnswers["character"];
  previewCopy?: PreviewCopy;
};

export const splitSharedBrief = (brief: SharedBrief): { type: TypeAnswers | null } => ({
  type: brief.route === "collection" ? null : {
    artifactType: brief.artifactType ?? "other",
    ...(brief.otherDecision ? { otherDecision: brief.otherDecision } : {}),
    existingFontConstraint: brief.existingFontConstraint ?? "unknown",
    ...(brief.mandatoryFontName ? { mandatoryFontName: brief.mandatoryFontName } : {}),
    authoringTool: brief.authoringTool ?? "unknown",
    handoffPaths: [...(brief.handoffPaths ?? ["pdf"])],
    viewingContexts: [...(brief.viewingContexts ?? ["mixedUnknown"])],
    density: brief.density ?? "varied",
    contentNeeds: [...(brief.contentNeeds ?? ["wordsImages"])],
    writingSystems: [...(brief.writingSystems ?? ["latin"])],
    character: brief.character ?? "unknown",
  },
});

export const pendingQuestionIds = (brief: SharedBrief): string[] => {
  if (brief.route === "collection") return [];
  const pending: string[] = [];
  const deep = brief.typePath === "deep";
  if (!brief.artifactType) pending.push("artifactType");
  if (!brief.existingFontConstraint) pending.push("existingFontConstraint");
  if (brief.existingFontConstraint === "mandatory" && !brief.mandatoryFontName?.trim()) pending.push("mandatoryFontName");
  if (deep && !brief.authoringTool) pending.push("authoringTool");
  if (deep && (!brief.handoffPaths || brief.handoffPaths.length === 0)) pending.push("handoffPaths");
  if (deep && (!brief.viewingContexts || brief.viewingContexts.length === 0)) pending.push("viewingContexts");
  if (!brief.density) pending.push("density");
  if (deep && (!brief.contentNeeds || brief.contentNeeds.length === 0)) pending.push("contentNeeds");
  if (deep && (!brief.writingSystems || brief.writingSystems.length === 0)) pending.push("writingSystems");
  if (!brief.character) pending.push("character");
  return pending;
};
